module.exports = __webpack_public_path__ + "img/p.4cae8e09.png";